import { useState, useEffect } from 'react'

export const useDebugMode = () => {
  const [isDebugMode, setIsDebugMode] = useState(false)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const debugParam = params.get('debug')

    if (debugParam === 'true') {
      setIsDebugMode(true)
    }

    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === 'D') {
        e.preventDefault()
        setIsDebugMode(prev => !prev)
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [])

  return {
    isDebugMode,
    setIsDebugMode
  }
}
